// Settings can be changed on the server without rebuilding: edit /config.js next to index.html.
// A key present in window.APP_CONFIG (even an empty string) wins; otherwise the build-time REACT_APP_* value is used.
export function cfg(key, buildTimeValue = '') {
  const runtime = typeof window !== 'undefined' ? window.APP_CONFIG : undefined;
  if (runtime && Object.prototype.hasOwnProperty.call(runtime, key) && runtime[key] != null) return String(runtime[key]);
  return buildTimeValue || '';
}
